import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { LOGOUT } from 'mocks/mutations';
import useUserData from 'data-hooks/useUserData';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';
import CustomerDashboardPageTemplateUI from './CustomerDashboardPageTemplateUI';
const CustomerDashboardPageTemplate = t0 => {
  const $ = _c(13);
  const {
    children,
    parentPageItem,
    showBreadcrumb: t1,
    showSidebar: t2,
    showTitle: t3,
    title,
    titleComponent: t4
  } = t0;
  const showBreadcrumb = t1 === undefined ? true : t1;
  const showSidebar = t2 === undefined ? true : t2;
  const showTitle = t3 === undefined ? true : t3;
  const titleComponent = t4 === undefined ? null : t4;
  const {
    email
  } = useUserData();
  const [logout] = useMutation(LOGOUT);
  const logoutClient = useLogoutClient();
  let t5;
  if ($[0] !== logout || $[1] !== logoutClient) {
    t5 = async () => {
      await logout();
      logoutClient();
      window.location.replace("/");
    };
    $[0] = logout;
    $[1] = logoutClient;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const onLogoutClick = t5;
  let t6;
  if ($[3] !== children || $[4] !== email || $[5] !== onLogoutClick || $[6] !== parentPageItem || $[7] !== showBreadcrumb || $[8] !== showSidebar || $[9] !== showTitle || $[10] !== title || $[11] !== titleComponent) {
    t6 = <CustomerDashboardPageTemplateUI email={email} onLogoutClick={onLogoutClick} parentPageItem={parentPageItem} showBreadcrumb={showBreadcrumb} showSidebar={showSidebar} showTitle={showTitle} title={title} titleComponent={titleComponent}>{children}</CustomerDashboardPageTemplateUI>;
    $[3] = children;
    $[4] = email;
    $[5] = onLogoutClick;
    $[6] = parentPageItem;
    $[7] = showBreadcrumb;
    $[8] = showSidebar;
    $[9] = showTitle;
    $[10] = title;
    $[11] = titleComponent;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
CustomerDashboardPageTemplate.propTypes = {
  children: PropTypes.node,
  parentPageItem: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string
  }),
  showBreadcrumb: PropTypes.bool,
  showSidebar: PropTypes.bool,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  titleComponent: PropTypes.string
};
export default CustomerDashboardPageTemplate;